import ReceiptIcon from "./ReceiptIcon";

export default function ReceiptItems({ services, totalCost }) {
  return <section className="receipt-items">
    <header><div><ReceiptIcon name="receipt" /><h2>جزئیات سرویس‌ها</h2></div><span>{services.length.toLocaleString("fa-IR")} مورد</span></header>
    <div className="receipt-items__list">{services.map((item, index) => <article key={`${item.categoryId}-${index}`}>
      <span>{(index + 1).toLocaleString("fa-IR")}</span><div><h3>{item.title || `سرویس ${item.categoryId}`}</h3>{item.brand && <p>برند یا مدل: {item.brand}</p>}{item.description && <p>{item.description}</p>}</div><b>{item.cost ? `${Number(item.cost).toLocaleString("fa-IR")} ریال` : "ثبت نشده"}</b>
    </article>)}</div>
    <footer><span>جمع هزینه خدمات</span><b>{totalCost ? `${totalCost.toLocaleString("fa-IR")} ریال` : "ثبت نشده"}</b></footer>
  </section>;
}
